import { useMutation } from '@tanstack/react-query';
import * as qs from 'qs';

import { apiClient } from '@services/apiClient';

import type { IUseArchivedAiInfiniteListKeys } from '../model/archivedAi';

const exportArchiveActionItemsFn = (keys: IUseArchivedAiInfiniteListKeys) => {
  const { causeCategory, costAvoidedRange, locationIds, searchValue, sorting, timeUpdatedRange, type } = keys;
  const { minCostAvoided, maxCostAvoided } = costAvoidedRange;
  const { minTimeUpdated, maxTimeUpdated } = timeUpdatedRange;

  const params = {
    location_ids: locationIds,
    search: searchValue || undefined,
    filter: {
      cause_category: causeCategory.value === 'all' ? undefined : causeCategory.value,
      time_updated_range:
        minTimeUpdated && maxTimeUpdated ? `${minTimeUpdated} - ${maxTimeUpdated}` : undefined,
      cost_avoided_range:
        minCostAvoided && maxCostAvoided ? `${minCostAvoided} - ${maxCostAvoided}` : undefined,
      type: type.value === 'all' ? undefined : type.value,
    },
    sort: {
      field: sorting.id ? sorting?.id : undefined,
      direction: !sorting.id ? undefined : sorting.desc ? 'desc' : 'asc',
    },
  };
  return apiClient.get(`${APP_API_URL_V2}fsd/action-item/report/archived-action-items/export`, {
    params,
    paramsSerializer: {
      serialize: (params) => qs.stringify(params),
    },
    responseType: 'arraybuffer',
    headers: {
      Accept: 'application/octet-stream',
    },
  });
};

export const useExportArchiveActionItemsMutation = () => {
  return useMutation({
    mutationFn: exportArchiveActionItemsFn,
  });
};
